<template>
  <div>

    <div class="row mb-3">
      <div class="col-3">
        <div class="select-icon dropdown">
          <div name="shape" class="chevron-dropdown" data-toggle="dropdown">
            <div>{{ $t('admin.users.departments') }}</div>
            <div class="icon">
            </div>
          </div>
          <div class="dropdown-menu keep-open-on-click">
            <div class="custom-control custom-checkbox" v-for="(department, index) in getCompanyDepartments"
                 :key="'department-'+index">
              <input v-model="filter.departments"
                     :value="department"
                     type="checkbox"
                     :id="'department-'+index"
                     class="custom-control-input"
              >
              <label class="custom-control-label" :for="'department-'+index">
                <span>{{ department }}</span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="col-3">
        <div class="select-icon dropdown">
          <div name="shape" class="chevron-dropdown" data-toggle="dropdown">
            <div>{{$t('menu.workflows')}}</div>
            <div class="icon">
            </div>
          </div>
          <div class="dropdown-menu keep-open-on-click">
            <div class="custom-control custom-checkbox" v-for="(wf, index) in getFilterdWorkflows"
                 :key="'wf-'+index">
              <input v-model="filter.workflows"
                     :value="wf.id"
                     type="checkbox"
                     :id="'wf-'+index"
                     class="custom-control-input"
              >
              <label class="custom-control-label" :for="'wf-'+index">
                <span>{{ wf.name }}</span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="col-3">

        <DatePicker class='date-picker'
                    prefix-class="xmx"
                    v-model="filter.dateRange"
                    format="DD-MM-YYYY"
                    :editable="false"
                    :clearable="false"
                    :confirm="false"
                    :disabled-date="disabledDates"
                    :append-to-body="true"
                    range>

        </DatePicker>
      </div>


      <div class="col-3">
        <div class="mt-3  " style="line-height:22.5px">
          <button class="btn btn-dark float-right" v-if=tableData.length @click="csvExport()">{{ $t('ui.export') }}</button>
          <button class="btn btn-primary float-left" @click="fetchData()">Filter</button>

        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <router-view ref=viewChild :filter="filter"/>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

import DatePicker from 'vue2-datepicker';
import './../../assets/scss/plugins/datepicker.scss';
import axios from "axios";


export default {
  name: "ConditionMonitoring",
  components: {DatePicker},
  data() {
    return {
      tableData: [],
      uniqueProducts: [],
      daterangeShortcuts: [
        {
          text: this.$t('ui.timespan.yesterday'),
          onClick() {

            return [moment().subtract(1, "day").toDate(), moment().subtract(1, "day").toDate()];
          },
        },
        {
          text: this.$t('ui.timespan.currentWeek'),
          onClick() {

            return [moment().startOf("week").toDate(), moment().startOf("week").toDate()];
          },
        },
      ],
      filter: {
        dateRange: [new Date(), new Date()],
        departments: [],
        workflows: [],

      },

    }
  },
  computed: {
    ...mapGetters('company', ['getCompanyDepartments']),
    ...mapGetters('workflows', ['getWorkflows']),
    getFilterdWorkflows() {
      return _.filter(this.getWorkflows, wf => {

        if (this.filter.departments.length) {
          let contains = false
          _.each(wf.departments, dep => {
            if (_.includes(this.filter.departments, dep)) {
              contains = true
            }
          })
          return contains
        } else {
          return wf
        }
      })
    },
    getUniqProducts() {
      return this.uniqueProducts
    }
  },
  methods: {
    async csvExport() {
    return  this.exportExcel(this.tableData,`ProductionRuns-power-${moment(this.filter.dateRange[0]).format('DD-MM-YYYY')}-${moment(this.filter.dateRange[1]).format('DD-MM-YYYY')}`)


    },
    disabledDates(date) {
      return moment(date).isBefore(moment('2022-11-14'))
    },
    async fetchData() {
      // getData is triggered in the ROUTES component
      // Returning unique products will fill the products filter on top of page
      if (!this.filter.workflows.length) {
        return this.$swal({text: this.$t('conditionMonitoring.noworkflowSelected')})
      }
      let data = await this.$refs.viewChild.getData()

      this.tableData = data
    }
  }

}
</script>

<style lang="scss" scoped>

::v-deep  .date-picker {
  //line-height: 22.5px;
  border: 1px solid #CED4DA;

  border-radius: 8px;
  padding: 8px;
  margin: 7px 0;
  background: white;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 8px;
  color: black;


}

.dropdown-menu {
  border-radius: 8px;
  width: 100%;
}

.dropdown-item {
  cursor: pointer;
}

.dropdown-item-top {
  border: 1px solid #CED4DA;
  margin-bottom: 1rem;
  padding-bottom: 1rem;
}

.chevron-dropdown {
  -webkit-appearance: none;
  width: 100%;
  padding: 12px 12px 12px 12px;
  margin: 8px 0;
  display: grid;
  grid-template-columns: 1fr auto;
  border: 1px solid #CED4DA;
  background: white;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 8px;
  color: black;
}

.dropdown-item:hover {
}

.chevron-dropdown[aria-expanded=true] {
  border-width: 2px;
}

.chevron-dropdown, .icon {
  cursor: pointer;
}

.chevron-dropdown > .icon {
  margin-left: 1rem;
}

.chevron-dropdown > .icon::before {
  display: inline-block;
  font-weight: bold;
  font-family: "Font Awesome 5 Pro";
  color: #2A52BE;
  content: "\f078";
}

.chevron-dropdown[aria-expanded=true] > .icon::before {
  display: inline-block;
  font-weight: bold;
  color: #2A52BE;
  font-family: "Font Awesome 5 Pro";
  content: "\f077";
}

$cerBlue: #2A52BE;
$blackCoral:#4F575E;

.btn {
  border-radius: 5px;
}

::v-deep  .btn-primary, ::v-deep  .btn-primary:hover, ::v-deep  .btn-primary-active {
  background: $cerBlue;
  border: 0;

}
::v-deep  .btn-dark, ::v-deep  .btn-dark:hover, ::v-deep  .btn-dark-active {
  background: $blackCoral;
  border: 0;

}
.custom-checkbox {
  border-radius: 8px;
  color: #000000;

  &.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
    background: $cerBlue;
  }

  &.custom-checkbox .custom-control-input:active ~ .custom-control-label::before {
    background-color: $cerBlue;
    border-color: $cerBlue;
  }
}
</style>